import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { observacionesEvaluacionPGD } from "../../Redux/evaluaciones";
import moment from "moment";

const useObservacionesPGD = (token, id) => {
    const dispatch = useDispatch();

    const [openModalObservaciones, setOpenModalObservaciones] = useState(false)



    const [observacionesEvaluacion, setObservacionesEvaluacion] = useState([])
    const [targetObservaciones, setTargetObservaciones] = useState({})
    const obsEvaluacionSelector = useSelector(store => store.evaluaciones.observacionesEv)


    useEffect(() => {
        if (token && id) {
            dispatch(observacionesEvaluacionPGD(token, id))
        }
    }, [token, id]);

    useEffect(() => {
        debugger;
        if (obsEvaluacionSelector.length > 0) {
          const newArray = obsEvaluacionSelector.map((element) => ({
            id: element.new_observaciondeobjetivoid,
            new_feedbacklider: element.new_feedbacklider,
            new_indicemensual: element.new_indicemensual,
            new_mes: element["new_mes@OData.Community.Display.V1.FormattedValue"]
          }))
          setObservacionesEvaluacion(newArray)
        }
      }, [obsEvaluacionSelector])
    
    const handleOpenObservaciones = (id, data) => {
      if (id) {
        setTargetObservaciones(data)
        setOpenModalObservaciones(true)
      }
    }

    return { observacionesEvaluacion, targetObservaciones, setObservacionesEvaluacion, setTargetObservaciones, handleOpenObservaciones, openModalObservaciones, setOpenModalObservaciones}
}

export default useObservacionesPGD